<template>
  <div id="keywordsComponent">
    <page-title :heading=heading :subheading=subheading :icon=icon></page-title>
    <v-container grid-list-md>
      <v-layout class="mb-2">
        <v-spacer></v-spacer>
        <v-flex class="text-xs-right">
          <v-dialog
            persistent
            v-model="dialog"
            max-width="600px"
          >
            <template v-slot:activator="{ on }">
              <v-btn
                color="primary"
                round
                outline
                v-on="on"
              >
                {{$t('keywords.add')}}
              </v-btn>
            </template>
            <v-card>
              <v-toolbar
                flat
              >
                <h2 class="font-weight-black primary--text mb-0">{{formTitle}}</h2>
              </v-toolbar>
              <v-card-text>
                <v-container grid-list-md>
                  <v-form
                  lazy-validation
                  ref="form"
                  v-model="valid"
                  >
                    <v-layout row wrap v-if="editedIndex > -1">
                      <v-flex xs12>
                        <v-autocomplete
                          v-model="editedItem.gst_categories_id"
                          :label="$t('general.category')"
                          :items="categories"
                          item-text="name"
                          item-value="id"
                          :error-messages="errors.gst_categories_id"
                          :rules="rules.required">
                          <template slot="selection" slot-scope="data">
                            {{ data.item.name}}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.name }}
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field
                          v-model="editedItem.keyword"
                          :label="$t('keywords.keyword')"
                          :error-messages="errors.keyword"
                          :rules="rules.noSpace">
                        </v-text-field>
                      </v-flex>
                    </v-layout>
                    <v-layout row wrap v-if="editedIndex <= -1">
                      <v-flex xs8>
                        <v-autocomplete
                          :disabled="disabled"
                          v-model="newKeywords.category"
                          :label="$t('general.category')"
                          :items="categories"
                          item-text="name"
                          item-value="id"
                          :error-messages="errors.gst_categories_id"
                          :rules="rules.required">
                          <template slot="selection" slot-scope="data">
                            {{  data.item.name}}
                          </template>
                          <template slot="item" slot-scope="data">
                            {{ data.item.name}}
                          </template>
                        </v-autocomplete>
                      </v-flex>
                      <v-flex xs12>
                        <v-combobox
                          v-model="newKeywords.keywords"
                          :label="$t('general.keywords')"
                          chips
                          multiple
                          :rules="rules.noSpace"
                          required
                        >
                          <template v-slot:selection="data">
                            <v-chip
                              :selected="data.selected"
                              close
                              @input="remove(data.item)"
                            >
                              <strong>{{ data.item }}</strong>&nbsp;
                            </v-chip>
                          </template>
                        </v-combobox>
                      </v-flex>
                    </v-layout>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="primary darken-1"
                  round
                  flat
                  @click="close"
                >
                  {{$t('general.close')}}
                </v-btn>
                <v-btn
                  v-if="editedIndex > -1"
                  color="error"
                  round
                  depressed
                  @click="removed(editedItem)"
                >
                  {{$t('general.delete')}}
                </v-btn>
                <v-btn
                  :loading="loading"
                  :disabled="loading"
                  color="primary"
                  round
                  depressed
                  @click="save"
                >
                  {{$t('general.submit')}}
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
      <v-layout row wrap>
        <v-flex xs6 v-for="category in processedKeywords" :key="category.id">
          <v-card>
            <v-toolbar flat>
              <h3 class="font-weight-black primary--text mb-0">{{$t('general.category')}}: <v-chip small color="primary" class="white--text">{{category.category}}</v-chip></h3>
            </v-toolbar>
            <v-card-text>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" @click="editItem(item)" v-for="item in category.keywords" :key="item.id" small round depressed class="grey lighten-2 primary--text">
                    <span>
                      # "{{item.keyword}}"
                    </span>
                  </v-btn>
                </template>
                <span>{{ $t('keywords.edit') }}</span>
              </v-tooltip>
            </v-card-text>
            <v-card-actions>
              <v-tooltip top>
                <template v-slot:activator="{ on }">
                  <v-btn color="primary" v-on="on" block flat @click="addKeywords(category.id)"><v-icon>add</v-icon></v-btn>
                </template>
                <span>{{ $t('keywords.add') }}</span>
              </v-tooltip>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-dialog v-model="removeDialog" max-width="500px">
        <v-card>
          <v-toolbar flat>
            <h2 class="font-weight-black error--text mb-0">{{ $t('keywords.delete') }}</h2>
          </v-toolbar>
          <v-card-text class="text-sm-justify">
            <p>{{ $t('general.deleteElementQuestion') }}</p>
            <p class="font-weight-black"><span class="error--text">{{ $t('keywords.keyword') }}: </span>"{{removedItem.keyword}}"</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              color="error darken-1"
              round
              flat
              @click="removeDialog = false">
              {{ $t('general.cancel') }}
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="loading"
              color="error"
              round
              depressed
              @click="deleteItem(removedItem)">
              {{ $t('general.delete') }}
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'keywordsComponent',
  data () {
    return {
      newKeywords: {
        category: null,
        keywords: null
      },
      defaultKeywords: {
        category: null,
        keywords: null
      },
      userLogged: {},
      errors: {},
      disabled: false,
      dialog: false,
      removeDialog: false,
      loading: false,
      valid: true,
      keywords: [],
      processedKeywords: [],
      removedItem: {},
      editedItem: {
        gst_categories_id: '',
        keyword: ''
      },
      defaultItem: {
        gst_categories_id: '',
        keyword: ''
      },
      editedIndex: -1,
      categories: []
    }
  },
  created () {
    if (this.$store.state.userLogged.company !== undefined) {
      this.getLogged()
    }
  },
  watch: {
    keywords () {
      this.processKeywords()
    },
    '$store.state.userLogged' () {
      this.getLogged()
    },
    userLogged () {
      this.initialize()
    }
  },
  computed: {
    options () {
      return [
        {text: this.$t('keywords.Es'), value: 'es'},
        {text: this.$t('keywords.En'), value: 'en'}
      ]
    },
    heading () {
      return this.$t('general.keywords')
    },
    subheading () {
      return ''
    },
    icon () {
      return 'fas fa-tags fa-fw icon-color'
    },
    rules () {
      return this.$validationRules()
    },
    formTitle () {
      return this.editedIndex === -1 ? this.$t('keywords.add') : this.$t('keywords.edit')
    }
  },
  methods: {
    remove (item) {
      if (this.newKeywords.keywords.length > 0) {
        let keywords = this.newKeywords.keywords
        keywords.splice(keywords.indexOf(item), 1)
        keywords = [...keywords]
      }
    },
    addKeywords (category) {
      this.dialog = true
      this.disabled = true
      this.newKeywords.category = category
      this.newKeywords.lang = 'es'
    },
    processKeywords () {
      let keywords = this.keywords
      let categories = []
      let processedKeywords = []
      for (let i = 0; i < keywords.length; i++) {
        const item = keywords[i]
        categories.push(item.category.id)
      }
      let unique = [...new Set(categories)]
      for (let j = 0; j < unique.length; j++) {
        const item = unique[j]
        let search = keywords.filter(element => element.gst_categories_id === item)
        processedKeywords.push({id: search[0].gst_categories_id, category: search[0].category.name, keywords: search})
      }
      this.processedKeywords = processedKeywords
    },
    close () { // close the dialog and re-assing default values
      this.dialog = false
      this.removeDialog = false
      this.disabled = false
      this.editedItem = Object.assign({}, this.defaultItem)
      this.newKeywords = Object.assign({}, this.defaultKeywords)
      this.editedIndex = -1
      this.errors = {}
      this.loading = false
      this.$refs.form.resetValidation()
    },
    editItem (item) {
      this.editedIndex = this.keywords.indexOf(item)
      this.editedItem = Object.assign({}, JSON.parse(JSON.stringify(item)))
      this.dialog = true
    },
    removed (item) {
      this.removedItem = item
      this.removeDialog = true
    },
    deleteItem (item) {
      this.loading = true
      this.$emit('delete', {context: this, item: item, company: this.userLogged.company[0]})
    },
    save () {
      this.errors = {}
      if (this.$refs.form.validate()) {
        this.loading = true
        if (this.editedIndex > -1) {
          this.$emit('put', {context: this, item: this.editedItem, company: this.userLogged.company[0]})
        } else {
          let send = Object.assign({}, this.newKeywords)
          let temp = []
          send.keywords.forEach(item => {
            item = {keyword: item}
            temp.push(item)
          })
          send.keywords = temp
          this.$emit('post', {context: this, item: send, company: this.userLogged.company[0]})
        }
      }
    },
    getLogged () {
      this.userLogged = this.$store.state.userLogged
    },
    initialize () {
      this.$emit('get', {context: this})
    },
    refresh () {
      this.$store.dispatch('keywords/get', {event: {context: this}})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/keywords.component.vue